<p-dialog
  [visible]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{ width: '54vw', maxWidth: '760px' }"
  [contentStyle]="{ overflow: 'visible' }"
  styleClass="arrange-grid-dialog"
  (visibleChange)="onCancel()"
  (onHide)="onCancel()">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0"
      icon="fas fa-grip"
      text="Anordnen"
      sub="Ziehen Sie die Kacheln, um die Anordnung des Grids zu ändern.">
    </app-header>
  </ng-template>

  <div class="flex gap-3 align-items-start">
    <div class="flex flex-column gap-2 flex-1 min-w-0">
      <div class="flex align-items-center gap-2 flex-wrap">
        <app-search-input
          class="flex-1"
          style="min-width: 9rem"
          placeholder="Kachel suchen…"
          [searchValue]="searchQuery"
          [showClearButton]="true"
          (search)="searchQuery = $event"></app-search-input>

        <p-button
          icon="fas fa-rotate-left"
          severity="secondary"
          [text]="true"
          [rounded]="true"
          size="small"
          pTooltip="Rückgängig (Strg+Z)"
          tooltipPosition="top"
          [disabled]="!canUndo"
          (onClick)="undo()"></p-button>

        <p-button
          icon="fas fa-broom"
          severity="secondary"
          [text]="true"
          [rounded]="true"
          size="small"
          pTooltip="Automatisch anordnen"
          tooltipPosition="top"
          (onClick)="compactLayout()"></p-button>

        <div class="flex align-items-center gap-1">
          <p-button
            icon="fas fa-magnifying-glass-minus"
            severity="secondary"
            [text]="true"
            [rounded]="true"
            size="small"
            pTooltip="Verkleinern"
            tooltipPosition="top"
            (onClick)="zoomOut()"></p-button>
          <span
            class="text-xs text-color-secondary text-center cursor-pointer select-none"
            style="min-width: 2.75rem"
            pTooltip="Zoom zurücksetzen (100%)"
            tooltipPosition="top"
            (click)="resetZoom()"
            >{{ zoomLevel * 100 | number: '1.0-0' }}%</span
          >
          <p-button
            icon="fas fa-magnifying-glass-plus"
            severity="secondary"
            [text]="true"
            [rounded]="true"
            size="small"
            pTooltip="Vergrößern (auch Strg+Scroll)"
            tooltipPosition="top"
            (onClick)="zoomIn()"></p-button>
        </div>
      </div>

      <div
        class="arrange-grid-container surface-ground border-round-xl p-3"
        style="max-height: 55vh; overflow: auto"
        (wheel)="onWheelZoom($event)"
        (click)="deselectTile()">
        <div class="grid-stack" #miniGrid>
          @for (item of items; track item.id) {
            <div
              class="grid-stack-item"
              [attr.gs-x]="item.x"
              [attr.gs-y]="item.y"
              [attr.gs-w]="item.w"
              [attr.gs-h]="item.h"
              [attr.gs-id]="item.id">
              <div
                class="grid-stack-item-content surface-card border-round-xl shadow-2"
                [class.arrange-tile--selected]="isSelected(item.id)"
                [class.arrange-tile--dimmed]="!matchesSearch(item)"
                [attr.aria-label]="getTileLabel(item)"
                [pTooltip]="!showTileLabels ? getTileLabel(item) : ''"
                tooltipPosition="top"
                (click)="$event.stopPropagation(); selectTile(item.id)">
                <app-widget-arrange-placeholder
                  [type]="item.type"
                  [headline]="item.widget?.headline"
                  [showLabel]="showTileLabels" />
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="arrange-hint border-round-xl p-3 flex flex-column gap-3">
      <span class="text-xs font-semibold text-color-secondary uppercase"
        >So funktioniert's</span
      >
      <div class="flex flex-column gap-3">
        <div class="flex align-items-start gap-2">
          <i class="fas fa-up-down-left-right text-primary mt-1"></i>
          <span class="text-sm text-color-secondary"
            >Kachel ziehen, um sie zu verschieben</span
          >
        </div>
        <div class="flex align-items-start gap-2">
          <i
            class="fas fa-up-right-and-down-left-from-center text-primary mt-1"></i>
          <span class="text-sm text-color-secondary"
            >Am Rand ziehen, um die Größe zu ändern</span
          >
        </div>
        <div class="flex align-items-start gap-2">
          <i class="fas fa-check text-primary mt-1"></i>
          <span class="text-sm text-color-secondary"
            >"Übernehmen" speichert die neue Anordnung</span
          >
        </div>
        <div class="flex align-items-start gap-2">
          <i class="fas fa-xmark text-primary mt-1"></i>
          <span class="text-sm text-color-secondary"
            >"Abbrechen" verwirft alle Änderungen</span
          >
        </div>
        <div class="flex align-items-start gap-2">
          <i class="fas fa-keyboard text-primary mt-1"></i>
          <span class="text-sm text-color-secondary"
            >Kachel anklicken, dann mit Pfeiltasten verschieben · Strg+Z macht
            rückgängig · Enter übernimmt</span
          >
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex align-items-center justify-content-between">
      <p-button
        size="small"
        icon="fas fa-xmark"
        label="abbrechen"
        severity="secondary"
        [text]="true"
        [rounded]="true"
        pTooltip="Verwirft alle Änderungen (Esc)"
        tooltipPosition="top"
        (onClick)="onCancel()"></p-button>
      <p-button
        label="übernehmen"
        icon="fas fa-check"
        [rounded]="true"
        pTooltip="Speichert die neue Anordnung (Enter)"
        tooltipPosition="top"
        (onClick)="onApply()"></p-button>
    </div>
  </ng-template>
</p-dialog>
